module.exports = __webpack_public_path__ + "static/img/1.85bce52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/1.png
// module id = Hfa8
// module chunks = 0